// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__99-rt","title":"Info_title__X2iJM","links":"Info_links__16xzJ","link":"Info_link__2PA-Y","logo":"Info_logo__1WYom"};